import { Container, Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useState } from 'react';
import { useCompras } from './hooks/useCompras';
import CompraForm from './CompraForm';
import ComprasTable from './ComprasTable';
import ComprasResumen from './ComprasResumen';

export default function LibroComprasApp() {
  const { compras, agregarCompra, editarCompra, anularCompra } = useCompras();
  const [editing, setEditing] = useState(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Typography variant="h4" align="center" gutterBottom>
        📘 Libro de Compras
      </Typography>

      <ComprasResumen compras={compras} />

      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <CompraForm
            editing={editing}
            onSubmit={data => {
              editing ? editarCompra(editing.id, data) : agregarCompra(data);
              setEditing(null);
            }}
          />
        </Grid>

        <Grid item xs={12} md={8}>
          <ComprasTable
            compras={compras}
            onEdit={setEditing}
            onAnular={anularCompra}
          />
        </Grid>
      </Grid>
    </Container>
  );
}
